var map = {
	"./Dashboard": 73534,
	"./Dashboard copy": 79089,
	"./Dashboard copy.js": 79089,
	"./Dashboard.js": 73534,
	"./DashboardConfig": 75448,
	"./DashboardConfig copy": 92455,
	"./DashboardConfig copy.js": 92455,
	"./DashboardConfig.js": 75448,
	"./DashboardConfig0": 65437,
	"./DashboardConfig0.js": 65437,
	"./DashboardConfigAdd": 54412,
	"./DashboardConfigAdd.js": 54412,
	"./DashboardConfigAdd0": 48326,
	"./DashboardConfigAdd0.js": 48326,
	"./DashboardConfigEdit": 32391,
	"./DashboardConfigEdit.js": 32391,
	"./DashboardConfigEdit0": 24052,
	"./DashboardConfigEdit0.js": 24052,
	"./DashboardGroupList": 22849,
	"./DashboardGroupList.js": 22849,
	"./DashboardGroupListAdd": 41005,
	"./DashboardGroupListAdd.js": 41005,
	"./DashboardGroupListEdit": 54190,
	"./DashboardGroupListEdit.js": 54190,
	"./DashboardList": 73950,
	"./DashboardList.js": 73950,
	"./DashboardListAdd": 2475,
	"./DashboardListAdd.js": 2475,
	"./DashboardListEdit": 96933,
	"./DashboardListEdit.js": 96933,
	"./DashboardsEdit": 44040,
	"./DashboardsEdit.js": 44040,
	"./WidgetPositionConfig": 74233,
	"./WidgetPositionConfig.js": 74233
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85799;